import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";

gsap.registerPlugin(ScrollTrigger, CustomEase);

// Stessa ease "dolce" del resto del sito: cubic-bezier(0.65,0,0.35,1).
CustomEase.create("sweet", "M0,0 C0.65,0 0.35,1 1,1");

// Punto di start dei reveal: piu' basso = scatta piu' tardi (elemento piu' in vista).
const REVEAL_START = "top 75%";
// La maschera immagine scatta un po' piu' tardi (immagini spesso piu' alte).
const MASK_START = "top 65%";

// Legge una custom property CSS (es. --reveal-delay) e la converte in secondi.
const cssSeconds = (el, prop, fallback) => {
  const raw = getComputedStyle(el).getPropertyValue(prop).trim();
  if (!raw) return fallback;
  const n = parseFloat(raw);
  if (Number.isNaN(n)) return fallback;
  return raw.endsWith("ms") ? n / 1000 : n;
};

// Reveal a classi: ogni .reveal entra in dissolvenza dal basso quando raggiunge
// il viewport. Ritardo via .reveal--delay-N (--reveal-delay), durata opzionale
// via --reveal-duration. Rispetta prefers-reduced-motion.
const reveal = () => {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const run = () => setup();

  // Se l'intro dell'hero-split e' in corso, i trigger vanno creati DOPO: a intro
  // finita il pin cambia le posizioni (altrimenti i reveal scattano a vuoto sotto
  // l'overlay dell'intro). Aspettiamo l'evento; altrimenti creiamo subito.
  if (document.documentElement.classList.contains("hero-split-intro")) {
    document.addEventListener("hero-split:intro-done", run, { once: true });
  } else {
    run();
  }
};

const setup = () => {
  gsap.utils.toArray(".reveal").forEach((el) => {
    const delay = cssSeconds(el, "--reveal-delay", 0);
    const duration = cssSeconds(el, "--reveal-duration", 1.1);

    // fromTo: GSAP tiene lo stato nascosto e riproduce solo quando il trigger e'
    // attivato. once => una sola volta. Lo scrollTrigger calcola la posizione al
    // refresh, quindi resta corretto anche con il pin dell'hero.
    gsap.fromTo(
      el,
      { autoAlpha: 0, y: 30 },
      {
        autoAlpha: 1,
        y: 0,
        duration,
        delay,
        ease: "sweet",
        scrollTrigger: {
          trigger: el,
          start: REVEAL_START,
          once: true,
        },
      }
    );
  });

  // Variante immagine: la maschera scopre dall'alto verso il basso (clip-path) +
  // micro-scale dell'immagine interna. Wrapper .reveal-mask con <img> dentro.
  gsap.utils.toArray(".reveal-mask").forEach((el) => {
    const img = el.querySelector("img") || el.firstElementChild;

    const build = () => {
      const delay = cssSeconds(el, "--reveal-delay", 0);
      const duration = cssSeconds(el, "--reveal-duration", 1.2);
      const tl = gsap.timeline({
        delay,
        scrollTrigger: { trigger: el, start: MASK_START, once: true },
      });
      tl.fromTo(
        el,
        { clipPath: "inset(0% 0% 100% 0%)" },
        { clipPath: "inset(0% 0% 0% 0%)", duration, ease: "sweet" },
        0
      );
      if (img && img.tagName === "IMG")
        tl.fromTo(img, { scale: 1.06 }, { scale: 1, duration, ease: "sweet" }, 0);
      ScrollTrigger.refresh();
    };

    // Con immagini lazy la figure ha altezza ~0 finche' non carica: creiamo il
    // trigger solo a immagine caricata, cosi' lo start (REVEAL_START) e' corretto e
    // non scatta a vuoto al load.
    if (img && img.tagName === "IMG" && !img.complete) {
      img.addEventListener("load", build, { once: true });
      img.addEventListener("error", build, { once: true });
    } else {
      build();
    }
  });

  // Ricalcola le posizioni una volta che tutto e' pronto (immagini/font/pin).
  ScrollTrigger.refresh();
  window.addEventListener("load", () => ScrollTrigger.refresh());
};

export default reveal;
